import { ConditionType, DepthType, OperationType } from "@/types/ses/sesItemConfigTypes";
import { TConditionHints } from "./Condition.props";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	DEPTH_OPTIONS_LIST as DEPTH_OPTIONS_LIST_DATA,
	CONDITION_RUN_ACTION_TYPE_LIST,
	OPERATION_CONDITIONS_LIST as OPERATION_CONDITIONS_LIST_DATA,
	CONDITION_CONFIRMATION_LIST_VARIANTS,
} from "@/constants/robotConfigLists";
import {
	faArrowsLeftRight,
	faBan,
	faCalendarCheck,
	faCheck,
	faClock,
	faClockRotateLeft,
	faDatabase,
	faEnvelope,
	faEquals,
	faFlag,
	faGreaterThan,
	faGreaterThanEqual,
	faLessThan,
	faLessThanEqual,
	faNotEqual,
	faRulerCombined,
	faSitemap,
	faTextHeight,
	faThumbsDown,
	faThumbsUp,
	faXmark,
} from "@fortawesome/free-solid-svg-icons";

export const hintsForConditionType: TConditionHints = {
	action: "",
	dataElemSlaveData: "",
	categoryAction: "",
	endpointEntry: "hint_conditionEndpointEntryType",
	endpointRun: "",
	endpointRunInEntry: "hint_conditionEndpointRunInEntryType",
};

export const CONDITIONS_LIST_ICONS: Record<ConditionType | "yes" | "no", IconDefinition | string> = {
	interval: faClock,
	variable: "{ }",
	data: faDatabase,
	confirmation: faThumbsUp,
	break: faBan,
	yes: faThumbsUp,
	no: faThumbsDown,
	event: faCalendarCheck,
	or: faSitemap,
};

export const CONDITIONS_LIST: { value: ConditionType | "yes" | "no"; label: string }[] = [
	...CONDITION_RUN_ACTION_TYPE_LIST.filter((el) => el.type !== "confirmation" && el.type !== "or").map((el) => ({
		value: el.type as Exclude<ConditionType, "or" | "confirmation">,
		label: el.translation,
	})),
	...CONDITION_CONFIRMATION_LIST_VARIANTS.map((el) => ({ value: el.value as Exclude<ConditionType, "or" | "confirmation">, label: el.translation })),
	{ label: "selectItem_createOrBlock", value: "or" },
];

export const DEPTH_OPTIONS_ICONS: Record<DepthType, IconDefinition> = {
	all: faClockRotateLeft,
	endpoint: faFlag,
	fresh: faEnvelope,
};

export const DEPTH_OPTIONS_LIST: { value: DepthType; label: string }[] = [...DEPTH_OPTIONS_LIST_DATA.map((el) => ({ value: el.type, label: el.translation }))];

export const OPERATION_CONDITIONS_ICONS: Record<OperationType, IconDefinition> = {
	"=": faEquals,
	"!=": faNotEqual,
	">": faGreaterThan,
	">=": faGreaterThanEqual,
	"<": faLessThan,
	"<=": faLessThanEqual,
	exists: faCheck,
	not_exists: faXmark,
	"len=": faRulerCombined,
	"len>": faTextHeight,
	"len<": faArrowsLeftRight,
};

export const OPERATION_CONDITIONS_LIST: { value: OperationType; label: string }[] = [
	...OPERATION_CONDITIONS_LIST_DATA.map((el) => ({ value: el.operation, label: el.translation })),
];
